module.exports = __webpack_public_path__ + "static/media/fondation_de_france.e9c72256.jpg";